// @flow
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import path from 'ramda/es/path';

import action from 'app/common/lib/action';
// $FlowFixMe
import { SHOP_SHIPPING_CLEAR } from 'app/common/actions/shop/order/shipping';
import { useRouterParamsE } from 'app/common/context/WithRouterParams';

import OrderList from './OrderList';
import Checkout from './Checkout';
import ContextForCart from './ContextForCart';


/**
 * Корзина в 2 шага с оформлением.
 * --------
 * availableUuids объект для фильтрации школ,
 * доступных текущему пользователю в  формате:
 * { [uuid: string]: true, ... }
 */

type Props = {
  availableUuids: {
    [key: string]: boolean,
  }
}

const Cart = ({ availableUuids }: Props) => {
  const dispatch = useDispatch();
  const routerParams = useRouterParamsE(['step']);

  // очистка данных при уходе
  useEffect(() => () => {
    dispatch(action(SHOP_SHIPPING_CLEAR));
  }, [dispatch]);

  return (
    <ContextForCart.Provider value={{ availableUuids }}>
      {path(['params', 'step'], routerParams) === 'checkout'
        ? <Checkout {...routerParams} />
        : <OrderList {...routerParams} />}
    </ContextForCart.Provider>
  );
};

export default Cart;
